import fullLogo from '@/assets/logo/full_color.png';
import fullWhiteLogo from '@/assets/logo/full_white.png';
import { cn } from '@/utils/cn';
import { Image } from './Image';
interface LogoProps {
  variant?: 'full' | 'white';
  className?: string;
}

export const Logo = ({ className = '', variant = 'full' }: LogoProps) => {
  const getLogo = () => {
    switch (variant) {
      case 'full':
        return fullLogo;
      case 'white':
        return fullWhiteLogo;
      default:
        return fullLogo;
    }
  };

  return (
    <Image
      src={getLogo()}
      className={cn(`w-28 object-contain ${className}`)}
      alt="logo"
    />
  );
};
